// extracted by mini-css-extract-plugin
export default {"section":"About_section__RTe70","h2":"About_h2__SUw0Q"};